import type { DriverManifest, DriverManifestRoute } from "@/lib/logistics/driverTypes";
import { DriverStopCard } from "./DriverStopCard";

type Props = {
  manifest: DriverManifest;
  onStamp: (stopId: string, field: "arrived_at" | "departed_at") => void;
  stampingStopId: string | null;
};

function routeHeading(route: DriverManifestRoute): string {
  const when = route.scheduled_window_label?.trim()
    ? route.scheduled_window_label
    : route.scheduled_for
      ? new Date(route.scheduled_for).toLocaleString(undefined, {
          weekday: "short",
          month: "short",
          day: "numeric",
        })
      : "Unscheduled";
  return `${route.unit_label} · ${when}`;
}

export function DriverRouteList({ manifest, onStamp, stampingStopId }: Props) {
  if (!manifest.routes.length) {
    return (
      <p className="rounded-xl border border-dashed border-slate-300 p-6 text-center text-sm text-slate-600 dark:border-slate-600 dark:text-slate-400">
        No assigned routes in the next {manifest.horizon_days} days.
      </p>
    );
  }

  return (
    <div className="space-y-6">
      {manifest.routes.map((route) => (
        <section key={route.id} className="space-y-3">
          <header>
            <h2 className="text-lg font-bold text-slate-900 dark:text-slate-50">{routeHeading(route)}</h2>
            <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
              {route.route_state.replace(/_/g, " ")}
              {route.driver_name ? ` · ${route.driver_name}` : ""}
            </p>
          </header>
          <div className="space-y-3">
            {route.stops.map((stop) => (
              <DriverStopCard
                key={stop.id}
                stop={stop}
                unitLabel={route.unit_label}
                stamping={stampingStopId === stop.id}
                onStamp={(field) => onStamp(stop.id, field)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
